import { useMemo } from 'react'
import { Checkbox, MenuItem, ListItemText } from '@vapor/material'
import { Select, SelectProps } from '@mui/material'
import { useTenant } from 'src/app/hooks/context/context.hook'
import { useAvailableResourcesQuery } from 'src/api/api.generated'
import { addDays } from 'src/utils/date'

type ResourceTimeMultiSelectProps = SelectProps & {
  propertyId: string
  resourceTypeId: string
  start: Date
  end: Date
  time: {
    from: Date
    to: Date
  }
  value: string[]
  onChange: (event: string[]) => void
}

export const ResourceTimeMultiSelect = (props: ResourceTimeMultiSelectProps) => {
  const { propertyId, resourceTypeId, start, end, time, value, onChange, fullWidth, size } = props
  const { id: tenantId } = useTenant()

  const { data: resourceAvailabilityData, loading } = useAvailableResourcesQuery({
    variables: {
      tenantId,
      propertyId,
      resourceTypeId,
      start,
      end: addDays(new Date(end), 1),
      time,
    },
  })

  const availableIds = useMemo(() => {
    return resourceAvailabilityData?.getAllAvailableResources?.map((r) => r.id) ?? []
  }, [resourceAvailabilityData?.getAllAvailableResources])

  return (
    <>
      <Select //
        disabled={loading}
        multiple
        fullWidth={fullWidth}
        size={size}
        MenuProps={{ sx: { maxHeight: 425 } }}
        value={Array.isArray(value) ? value : []}
        onChange={(v) => {
          const ids = Array.isArray(v.target.value) ? v.target.value : [v.target.value]
          onChange(ids.filter((id) => availableIds.includes(id)))
        }}
        renderValue={(selected) => {
          return selected
            .map((selectedValue) => {
              return resourceAvailabilityData?.getAllAvailableResources?.find((r) => r.id === selectedValue)?.code
            })
            .join(', ')
        }}
      >
        {resourceAvailabilityData?.getAllAvailableResources?.map((r) => (
          <MenuItem key={r.id} value={r.id}>
            <Checkbox checked={(value ?? []).includes(r.id)} />
            <ListItemText primary={r.code} />
          </MenuItem>
        ))}
      </Select>
    </>
  )
}
